type WaitForElementResult = {
  elementPromise: Promise<HTMLElement>;
  observer: MutationObserver;
};

export function waitForElement(selector: string): WaitForElementResult {
  let observer: MutationObserver | null = null;

  const elementPromise = new Promise<HTMLElement>((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector) as HTMLElement);
    }

    observer = new MutationObserver(() => {
      const el = document.querySelector(selector);

      if (el) {
        observer.disconnect();
        resolve(el as HTMLElement);
      }
    });

    // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      // A selector can match on an attribute (e.g. `[aria-hidden="false"]`), and an element may
      // start matching without any node being added or removed. jQuery UI tabs switch panels by
      // mutating attributes only, so without this the observer would never fire. See SITH-433.
      attributes: true,
      attributeFilter: ['aria-hidden'],
    });

    return null;
  });

  return { elementPromise, observer };
}
